import React from 'react';
import { Box, Checkbox, FormControlLabel, FormGroup, Grid, Typography } from '@mui/material';
import { FormData } from 'src/interfaces/iproptypes';
import { COLOR_GREY_400 } from 'src/utils/colors';

const Timeline = ({
  formData,
  setFormData,
}: {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
}) => {
  const timelineOptions = ['0-3 months', '3-6 months', '6+ months'];

  const handleTimelineChange = (value: string) => {
    setFormData({ ...formData, timeline: value });
  };

  return (
    <Box>
      <Typography variant="h3" sx={{ fontSize: '24px', textAlign: 'center' }}>
        What is your timeline?
      </Typography>

      <FormGroup sx={{ mt: '20px' }}>
        {timelineOptions.map(option => (
          <FormControlLabel
            key={option}
            control={
              <Checkbox
                checked={formData.timeline === option}
                onChange={() => handleTimelineChange(option)}
                sx={{ color: COLOR_GREY_400 }}
              />
            }
            label={option}
            sx={{ pl: '40px' }}
          />
        ))}
      </FormGroup>
    </Box>
  );
};

export default Timeline;
